import type { LinksLookup } from 'src/translators/links-lookup';

// When modifying an existing entry here, you might need to add an NGINX redirect from the old URL to the new one,
// in netherlands.template
export const linksLookup: LinksLookup = {
  'book-a-tour': 'boek-een-rondleiding',
  'club-facilities': 'clubfaciliteiten',
  'club-treatments': 'club-treatments',
  'club-fitness': 'club-fitness',
  'creche': 'kinderopvang',
  'exercise-classes': 'groepslessen',
  'gym': 'gym',
  'sports': 'sports',
  'kids-classes': 'lessen-voor-kids',
  'children': 'children',
  'pools': 'zwembaden',
  'spa': 'wellness',
  'tennis': 'tennis',
  'enquire-now': 'vraag-nu-aan',
  'enquiry-form': 'vraag-nu-aan',
  'family-and-kids': 'gezin-en-kids',
  'golf': 'golf',
  'join-now': 'word-nu-lid',
  'membership-trial': 'lidmaatschapstrial',
  'manage-your-tour': 'beheer-je-rondleiding',
  'relax-and-socialise': 'ontspannen-en-socialisen',
  'timetable': 'rooster',
  'yoga': 'yoga',
  'blaze': 'blaze',
  'personal-training': 'personal-training',
  'join': 'inschrijven',
  // If this link is changed, we should also update the links stored in CC
  // E.g. see DLLABS-10292
  'join-online': 'sluit-online-aan',
  'treatments': 'face-body-spa',
  'global-enquire-now': 'vraag-nu-aan',
  'memberships': 'lidmaatschappen',
  'terms-and-conditions': 'voorwaarden',
  'policy': 'beleid',
  'gyms-in-rotterdam': 'sportscholen-in-rotterdam',
  'careers': 'carrieres',
  'digital-signature': 'digitale-handtekening',
  'young-adult': 'jongvolwassene',
  'family': 'familie',
};
